import { isAbUseExperimentGroup } from './isAbUseExperimentGroup';
import { AUD_AUTH_TRAP } from '../../constants/experiments';
import { IAbUseExperiment } from '../../types/abUseExperiments';

export function selectIsAuthorizationTrapExperimentEnabled(experiments: IAbUseExperiment[] = []) {
  return isAbUseExperimentGroup(experiments, AUD_AUTH_TRAP, 'B');
}
